// extracted by mini-css-extract-plugin
export default {"title":"MarketplaceItem__title--Ia8MS","desc":"MarketplaceItem__desc--+v3wm","price":"MarketplaceItem__price--rZGvK","regularPrice":"MarketplaceItem__regularPrice--OU9Dy"};